<template>
  <div class="card card-content card--interactive text-center">
    <CommPopper ref="comPopper">
      <div
        slot="content"
        class="flex flex-col"
      >
        <a
          :href="editUrl"
          v-text="'Edit'"
        />
        <a
          v-if="managedPage.attributes.is_disabled"
          @click.prevent="openEnableModal"
          v-text="'Enable'"
        />
        <a
          v-else
          @click.prevent="openDisableModal"
          v-text="'Disable'"
        />
        <a
          @click.prevent="openDeleteModal"
          v-text="'Delete'"
        />
      </div>
    </CommPopper>
    <div class="flex-item">
      <a
        v-if="managedPage.attributes.icon"
        target="_self"
        :href="url"
      >
        <img
          :src="managedPage.attributes.icon"
          alt=""
        >
      </a>
      <h3 class="mb-4">
        <a
          target="_self"
          :href="url"
          v-text="managedPage.attributes.title"
        />
      </h3>
    </div>
  </div>
</template>

<script type="text/babel">
import CommPopper from 'Communication/Resources/assets/js/components/CommPopper'

export default {
  name: 'ManagedPageCard',
  components: {
    CommPopper,
  },
  props: {
    managedPage: {
      type: Object,
      required: true,
    },
  },
  computed: {
    url() {
      return this.$urlGenerator.active(`managed-pages/${this.managedPage.uuid}`)
    },
    editUrl() {
      return this.$urlGenerator.active(`managed-pages/${this.managedPage.uuid}/edit`)
    },
  },
  methods: {
    hidePopper() {
      this.$refs.comPopper.close()
    },
    openDeleteModal() {
      this.$emit('openDeleteModal', this.managedPage)

      this.hidePopper()
    },
    openDisableModal() {
      this.$emit('openDisableModal', this.managedPage)

      this.hidePopper()
    },
    openEnableModal() {
      this.$emit('openEnableModal', this.managedPage)

      this.hidePopper()
    },
  },
}
</script>
